import { ROUTE_URL } from '@/constant/route';
import AppLayout from "@/views/AppLayout";
import Error404 from "@/components/Error404";
export const publicRoute = [
    {
        //path: "*", component: maintaining,
        path: "*", component: Error404
    },
    {
        path: `/404`,
        name: "404",
        component: Error404
    },
    {
        path: `/${ROUTE_URL.REGISTER}`,
        name: "Register",
        component: () => import("@/views/auth/Login.vue")
    },
    {
        path: `/${ROUTE_URL.REGISTER_SUCCESS}`,
        name: "RegisterSuccess",
        component: () => import("@/views/component/RegisterSuccess.vue")
    },
    {
        path: `/register-succeed.html`,
        name: "RegisterSuccess2",
        component: () => import("@/views/component/RegisterSuccess.vue")
    },
    {
        path: `/${ROUTE_URL.LOGIN}`,
        name: "Login",
        component: () => import("@/views/auth/Login.vue")
    },
    {
        path: `/${ROUTE_URL.FORGOT_PASSWORD}`,
        name: "ForgotPassword",
        component: () => import("@/views/auth/Login.vue")
    },
    {
        path: `/${ROUTE_URL.PAYMENT_SUCCESS}`,
        name: "PaymentSuccess",
        component: () => import("@/views/component/PaymentThankYou.vue")
    },
    {
        path: `/${ROUTE_URL.REACTIVATE_EXPIRED}`,
        name: "PaymentSuccess",
        component: () => import("@/views/ReactivateAccount/ReactivateAccountExpired.vue")
    },
    {
        path: `/${ROUTE_URL.REACTIVATE_SUCCESS}`,
        name: "PaymentSuccess",
        component: () => import("@/views/ReactivateAccount/ReactivateAccountSuccess.vue")
    },
    {
        path: `/${ROUTE_URL.REACTIVATE_CHANGE_PASSWORD}`,
        name: "ReactiveChangePassword",
        component: () => import("@/views/auth/ReactiveChangePassword.vue")
    },
];

export const protectedRoute = [
    {
        path: "/",
        component: AppLayout,
        meta: { group: "apps", icon: "" },
        redirect: ROUTE_URL.DASHBOARD,
        children: [
            {
                path: ROUTE_URL.DASHBOARD,
                name: "DASHBOARD",
                meta: { requiresAuth: true },
                component: () => import("@/views/dashboard/Dashboard.vue")
            },
            {
                path: ROUTE_URL.GPUHUB,
                name: "GPUHUB",
                meta: { requiresAuth: true },
                component: () => import("@/views/RentalService/RentalContainer.vue")
            },
            {
                path: ROUTE_URL.CPUHUB,
                name: "CPUHUB",
                meta: { requiresAuth: true },
                component: () => import("@/views/RentalService/RentalContainer.vue")
            },
            {
                path: ROUTE_URL.EXTRA_SERVICE_CONTAINER,
                name: "EXTRA_SERVICE_CONTAINER",
                meta: { requiresAuth: true },
                component: () => import("@/views/ExtraService/ExtraServiceContainer.vue")
            },
            {
                path: ROUTE_URL.FIXED_RENTAL,
                name: "FIXED_RENTAL",
                meta: { requiresAuth: true },
                component: () => import("@/views/FixedRental/FixedRental.vue")
            },
            {
                path: ROUTE_URL.PAYMENT_MANAGEMENT,
                name: "PAYMENT_MANAGEMENT",
                meta: { requiresAuth: true },
                component: () => import("@/views/Payment/PaymentManagement.vue")
            },
            {
                path: ROUTE_URL.RECHARGE,
                name: "RECHARGE",
                meta: { requiresAuth: true },
                component: () => import("@/views/Payment/RechargeContainer.vue")
            },
            {
                path: ROUTE_URL.BILLING_HISTORY,
                name: "BILLING_HISTORY",
                meta: { requiresAuth: true },
                component: () => import("@/views/billing/BillingHistory.vue")
            },
            {
                path: ROUTE_URL.SUPPORT,
                name: "SUPPORT",
                meta: { requiresAuth: true },
                component: () => import("@/views/Support/Support.vue")
            },
            {
                path: ROUTE_URL.GET_HELP,
                name: "GET_HELP",
                meta: { requiresAuth: true },
                component: () => import("@/views/Help/Help.vue")
            },
            {
                path: ROUTE_URL.AFFILIATE_PROGRAM,
                name: "AFFILIATE_PROGRAM",
                meta: { requiresAuth: true },
                component: () => import("@/views/AffiliateProgram/AffiliateProgram.vue")
            },
            {
                path: ROUTE_URL.CUSTOMER_INFORMATION,
                name: "CUSTOMER_INFORMATION",
                meta: { requiresAuth: true },
                component: () => import("@/views/auth/CustomerInformationContainer.vue")
            },
            {
                path: ROUTE_URL.COUPONS,
                name: "COUPONS",
                meta: { requiresAuth: true },
                component: () => import("@/views/Coupons/Coupons.vue")
            },
            {
                path: ROUTE_URL.SETTINGS,
                name: "SETTINGS",
                meta: { requiresAuth: true },
                component: () => import("@/views/Settings/Settings.vue")
            },
            {
                path: ROUTE_URL.DOWNLOAD,
                name: "DOWNLOAD",
                meta: { requiresAuth: true },
                component: () => import("@/views/common/Download.vue")
            },
            {
                path: ROUTE_URL.USER_HISTORY,
                name: "USER_HISTORY",
                meta: { requiresAuth: true },
                component: () => import("@/views/userHistory/UserHistory.vue")
            },
            {
                path: ROUTE_URL.DEVELOPER_API,
                name: "DEVELOPER_API",
                meta: { requiresAuth: true },
                component: () => import("@/views/common/Api.vue")
            },
            {
                path: '/stake-management',
                name: "STAKE_POINT_API",
                meta: { requiresAuth: true },
                component: () => import("@/views/StakingPoint/StakingPoint.vue")
            },
        ]
    },
    {
        path: '/data-center',
        name: "DATA_CENTER",
        meta: { requiresAuth: true },
        component: () => import("@/views/auth/data-center/DataCenterSelect.vue")
    }
];
